<template>
    <section>
        <div class="cabinet-content-wrap">
            <SearchAndBasket />

            <div class="cabinet__logo"></div>

            <section class="cabinet__welcome-section">
                <h2 class="cabinet__welcome-section__title-h2">
                    Весь ювелирный рынок на одной площадке +
                </h2>

                <p class="cabinet__welcome-section__text">
                    Добро пожаловать на goldnet.market! Тут вы сможете найти
                    ювелирное изделие своей мечты и заказать его напрямую у
                    производителя. Удачных покупок!
                </p>

                <p class="cabinet__welcome-section__text">
                    Вы производитель ювелирных изделий или оптовый покупатель?
                    Тогда вам <a href="/partners">сюда</a>
                </p>

                <div class="cabinet__product-list_wrap">
                    <p v-if="loadingCategories.categories">Loading...</p>
                    <ul v-else class="cabinet__product-list">
                        <li
                            v-for="categorie in categoriesComputed.slice(0, 6)"
                            :key="categorie.CategoryID"
                            class="cabinet__product-list__product-item cabinet__product-list__product-item--new"
                        >
                            <router-link
                                :to="
                                    `/catalog/category/${categorie.CategoryID}`
                                "
                            >
                                <div
                                    class="cabinet__product-list__product-item__img"
                                >
                                    <img
                                        v-if="categorie.Image"
                                        :src="categorie.Image"
                                        :alt="categorie.Name"
                                    />
                                    <img
                                        v-else
                                        src="img/no-photo.jpg"
                                        :alt="categorie.Name"
                                    />
                                </div>
                                <h4
                                    class="cabinet__product-list__product-item__title-h4"
                                >
                                    {{ categorie.Name }}
                                </h4>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </section>

            <section class="cabinet-section cabinet__new-items mt-56 pt-0 pb-0">
                <div class="flex flex-justify-sb flex-align-start">
                    <h3 class="h3 cabinet-section__dashboard-title">Новинки</h3>
                    <!--  <a href="javascript:void(0)" class="cabinet-link"
                       >Все новинки</a
                   > -->
                </div>

                <div class="cabinet__catalog">
                    <p v-if="loadingItems.items || !products">Loading...</p>

                    <div
                        v-else-if="items && !isRetailer"
                        class="cabinet__catalog-container d-flex flex-wrap justify-content-between"
                    >
                        <div
                            v-for="item in items.slice(0, 8)"
                            :key="item.ItemID"
                            class="cabinet__catalog-item d-flex flex-column"
                        >
                            <router-link
                                :to="`/catalog/product/${item.ItemID}`"
                                class="cabinet__catalog-image"
                            >
                                <img
                                    v-if="item.images"
                                    :src="item.images[0].url"
                                    :alt="item.brand.BrandName"
                                />
                                <img
                                    v-else
                                    src="img/no-photo.jpg"
                                    :alt="item.brand.BrandName"
                                />
                            </router-link>

                            <div
                                class="cabinet__catalog-title d-flex align-items-center mb-auto"
                            >
                                <router-link
                                    :to="`/brands/${item.brand.BrandID}`"
                                    class="cabinet__catalog-title_value"
                                >
                                    {{ item.brand.BrandName }}
                                </router-link>
                            </div>

                            <div class="cabinet__catalog-category">
                                {{ item.Category_src }}
                            </div>

                            <div class="cabinet__catalog-code">
                                {{ item.Article }}
                            </div>

                            <div
                                class="cabinet__catalog-tags d-flex flex-wrap subtitle2"
                            >
                                <div
                                    v-for="material in item.materials"
                                    :key="material.MaterialID"
                                    class="cabinet__catalog-tag"
                                >
                                    <a href="javascript:void(0)">{{
                                        material.Name
                                    }}</a>
                                </div>
                            </div>

                            <div class="cabinet__catalog-info">
                                <div class="cabinet__catalog-price">
                                    {{ item.Price }} Р/шт
                                </div>
                                <div
                                    v-if="item.Weight"
                                    class="cabinet__catalog-weight"
                                >
                                    {{ item.Weight }} гр
                                </div>
                            </div>

                            <adding-and-deleting-to-public-cart :item="item" />
                        </div>
                        <div class="cabinet__catalog-item"></div>
                    </div>

                    <div
                        v-else
                        class="cabinet__catalog-container d-flex flex-wrap justify-content-between"
                    >
                        <retailer-product-item
                            v-for="product in products.slice(0, 8)"
                            :key="product.ItemID"
                            :product="product"
                        />
                    </div>
                </div>
            </section>

            <section class="dashboard-brand cabinet__brands">
                <div class="flex flex-justify-sb flex-align-start">
                    <h3 class="h3 cabinet-section__dashboard-title">Бренды</h3>
                    <router-link
                        v-if="!isRetailer"
                        to="/brands"
                        class="cabinet-link"
                        >Все бренды</router-link
                    >
                    <router-link
                        v-else
                        to="/account/brands"
                        class="cabinet-link"
                        >Все бренды</router-link
                    >
                </div>

                <div class="dashboard-scrollable__wrap-brand">
                    <p v-if="!brands">Loading...</p>

                    <div v-else class="dashboard-scrollable__content-brand">
                        <div
                            class="d-flex flex-lg-wrap dashboard-brand__row-retailer"
                        >
                            <div
                                v-for="brand in brands.slice(0, 8)"
                                :key="brand.BrandID"
                                class="dashboard-brand__card-retailer"
                            >
                                <div
                                    class="dashboard-brand__content dashboard-brand__content--retailer"
                                >
                                    <router-link
                                        :to="
                                            isRetailer
                                                ? `/account/brands/${brand.BrandID}`
                                                : `/brands/${brand.BrandID}`
                                        "
                                        class="app-link"
                                    >
                                        <img
                                            v-if="brand.logo"
                                            :src="brand.logo"
                                            :alt="brand.BrandName"
                                            class="dashboard-brand__img ofi"
                                        />
                                        <img
                                            v-else
                                            src="img/no-photo.jpg"
                                            :alt="brand.BrandName"
                                            class="dashboard-brand__img ofi"
                                        />
                                        <div class="dashboard-brand__title">
                                            {{ brand.BrandName }}
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /dashboard-scrollable__content -->
                </div>
                <!-- /dashboard-scrollable__wrap -->
            </section>
        </div>

        <section class="cabinet__what-is-goldnet">
            <div class="cabinet-content-wrap">
                <h2 class="cabinet__what-is-goldnet__title-h2">
                    Что такое goldnet.market?
                </h2>

                <ul class="cabinet__what-is-goldnet__list-of-services">
                    <li
                        class="cabinet__what-is-goldnet__list-of-services__item"
                    >
                        <h3
                            class="cabinet__what-is-goldnet__list-of-services__item__title-h3"
                        >
                            Широкий ассортимент
                        </h3>
                        <p
                            class="cabinet__what-is-goldnet__list-of-services__item__service-description"
                        >
                            На платформе размещен ассортимент ведущих
                            производителей и поставщиков ювелирных изделий всех
                            секторов рынка — от массового серебряного до
                            эксклюзивного и авторского.
                        </p>
                    </li>

                    <li
                        class="cabinet__what-is-goldnet__list-of-services__item cabinet__what-is-goldnet__list-of-services__item--2"
                    >
                        <h3
                            class="cabinet__what-is-goldnet__list-of-services__item__title-h3"
                        >
                            Покупка напрямую у производителей
                        </h3>
                        <p
                            class="cabinet__what-is-goldnet__list-of-services__item__service-description"
                        >
                            Вы отправляете заказ напрямую производителю, что
                            гарантирует подлинность изделий и отсутствие лишних
                            наценок.
                        </p>
                    </li>

                    <li
                        class="cabinet__what-is-goldnet__list-of-services__item"
                    >
                        <h3
                            class="cabinet__what-is-goldnet__list-of-services__item__title-h3"
                        >
                            Оптовые продажи
                        </h3>
                        <p
                            class="cabinet__what-is-goldnet__list-of-services__item__service-description"
                        >
                            Зарегистрируйте свое юридическое лицо или ИП, и
                            получите доступ к расширенному функционалу для более
                            эффективных оптовых закупок.
                        </p>
                    </li>
                </ul>
            </div>
        </section>

        <section class="cabinet__invitation-to-cooperation">
            <div class="cabinet-content-wrap">
                <h2 class="cabinet__invitation-to-cooperation__title-h2">
                    Приглашаем к сотрудничеству
                </h2>

                <p class="cabinet__invitation-to-cooperation__text">
                    Приглашаем присоединиться к нашей платформе оптовых
                    покупателей и поставщиков.
                </p>

                <a
                    href="/partners"
                    class="cabinet-btn cabinet-btn--default-link d-inline-block"
                >
                    Узнать больше
                </a>
            </div>
        </section>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import SearchAndBasket from '@/components/Public/SearchAndBasket'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'
import RetailerProductItem from '@/components/Cabinet/Retailer/ProductItem'

export default {
    name: 'Home',

    components: {
        SearchAndBasket,
        AddingAndDeletingToPublicCart,
        RetailerProductItem
    },

    computed: {
        ...mapState('retailerProducts', ['products']),
        ...mapGetters({
            categories: 'publicCategories',
            items: 'publicItems',
            loadingCategories: 'publicCategoriesLoading',
            loadingItems: 'publicItemsLoading',
            isRetailer: 'isRetailer'
        }),
        ...mapGetters('user', ['isRetailer']),
        ...mapState('publicBrands', ['brands']),
        categoriesComputed() {
            return this.categories
                .slice()
                .filter(el =>
                    el.types.reduce((acc, el2) => acc + el2.items_count, 0)
                )
        }
    },

    created() {
        if (this.isRetailer) {
            this.getProducts({ page: 1, sort_by: 'New' })
            this.getLists()
            this.getBrands({ sort_by: 'New' })
        } else {
            this.getPublicItems()
            this.getBrands({ sort_by: 'New' })
            this.setCartPublicFromLocStor()
        }
    },

    methods: {
        ...mapActions(['getPublicItems', 'setCartPublicFromLocStor']),
        ...mapActions('publicBrands', ['getBrands']),
        ...mapActions('retailerProducts', ['getProducts']),
        ...mapActions('retailerLists', ['getLists'])
    }
}
</script>
